import { createAction, props } from '@ngrx/store';

import { UserCounts } from '@offconon/core-api';

import { LayoutEntity } from './layout.models';

export const initLayout = createAction('[Layout Page] Init');

export const loadLayoutSuccess = createAction(
  '[Layout/API] Load Layout Success',
  props<{ layout: LayoutEntity[] }>(),
);

export const loadLayoutFailure = createAction(
  '[Layout/API] Load Layout Failure',
  props<{ error: any }>(),
);

export const setLeftColumnVisible = createAction(
  '[Layout/API] Set Left Column Visible',
  props<{ leftColumnVisible: boolean }>(),
);

export const setRightColumnVisible = createAction(
  '[Layout/API] Set Right Column Visible',
  props<{ rightColumnVisible: boolean }>(),
);

export const setLeftDrawerOpen = createAction(
  '[Layout/API] Set Left Drawer Open',
  props<{ leftDrawerOpen: boolean }>(),
);

export const setRightDrawerOpen = createAction(
  '[Layout/API] Set Right Drawer Open',
  props<{ rightDrawerOpen: boolean }>(),
);
export const asd = createAction('[Layout/API] Set Right asd');

export const getIndicators = createAction('[User/API] Load User Indicators');

export const getIndicatorsSuccess = createAction(
  '[User/API] Load User Indicators Success',
  props<{ counts: UserCounts }>(),
);
export const getIndicatorsFailure = createAction(
  '[User/API] Load User Indicators Failure',
  props<{ error: any }>(),
);
